import { Component } from '@angular/core';

/** One entry per warehousing report, rendered as the landing screen's buttons. */
export class WarehousingReportLink {
  name: string = '';
  description: string = '';
  link: string = '';
  icon: string = '';
}

@Component({
    selector: 'app-warehousing-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent {

  reports: WarehousingReportLink[] = [
    {
      name: 'Stock on Hand',
      description: 'Current level for every product and location, with a total.',
      link: '/warehousing/reports/stock-on-hand',
      icon: 'fas fa-layer-group'
    } as WarehousingReportLink,
    {
      name: 'Movement History',
      description: 'The audit trail. Every ledger row over a date range, by reference and type.',
      link: '/warehousing/reports/movement-history',
      icon: 'fas fa-history'
    } as WarehousingReportLink,
    {
      name: 'Adjustments',
      description: 'Signed adjustments only — stock written on or off outside a delivery.',
      link: '/warehousing/reports/adjustments',
      icon: 'fas fa-sliders-h'
    } as WarehousingReportLink,
    {
      name: 'Stock Reconciliation',
      description: 'Stored level against the level recomputed from the ledger. Any variance is a defect.',
      link: '/warehousing/reports/reconciliation',
      icon: 'fas fa-balance-scale'
    } as WarehousingReportLink,
    {
      name: 'Batch Traceability',
      description: 'Where each batch went and what it still holds, with the un-batched remainder beside it. Informational — nothing about a batch is enforced.',
      link: '/warehousing/reports/batch-traceability',
      icon: 'fas fa-barcode'
    } as WarehousingReportLink,
    {
      name: 'Slow Moving Stock',
      description: 'Stock currently held with no real movement in a while — oldest first. Informational only.',
      link: '/warehousing/reports/slow-moving',
      icon: 'fas fa-hourglass-half'
    } as WarehousingReportLink
  ];
}
